module.exports = __webpack_public_path__ + "img/banner_itemtwo_topimg.48592985.png";